"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var events_exports = {};
__export(events_exports, {
  createPlayerEvents: () => createPlayerEvents
});
module.exports = __toCommonJS(events_exports);
function createPlayerEvents(read, updateIntervalMs) {
  var listeners = /* @__PURE__ */ new Set();
  var timer = null;
  function emit() {
    var status = read();
    listeners.forEach(function(listener) {
      return listener(status);
    });
  }
  function stop() {
    if (timer !== null) {
      clearInterval(timer);
      timer = null;
    }
  }
  return {
    add(event, listener) {
      if (event !== "playbackStatusUpdate") {
        throw new Error("AudioPlayer.addListener: expected 'playbackStatusUpdate'");
      }
      if (typeof listener !== "function") {
        throw new Error("AudioPlayer.addListener: expected a listener function");
      }
      listeners.add(listener);
      if (timer === null) timer = setInterval(emit, updateIntervalMs);
      queueMicrotask(function() {
        if (listeners.has(listener)) listener(read());
      });
      return {
        remove: function remove() {
          listeners.delete(listener);
          if (listeners.size === 0) stop();
        }
      };
    },
    removeAll() {
      listeners.clear();
      stop();
    }
  };
}
//# sourceMappingURL=events.js.map
